var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"prevent-scroll",rawName:"v-prevent-scroll"}],staticClass:"main-content detail-overlay",attrs:{"id":"detail"}},[_c('span',{staticClass:"fake-link go-back hidden-print",on:{"click":_vm.goBack}},[_vm._v(" << Go back to search")]),_vm._v(" "),_c('detail')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }